import React, { useState, useEffect } from 'react';

const TipModal = ({ dataFields,dataDescriptions, isOpen, closeModal }) => {
  const [selectedSection, setSelectedSection] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleSectionClick = (index) => {
    setIsVisible(false); // Hide current content
    setTimeout(() => {
      setSelectedSection(index);
      setIsVisible(true); // Show new content with animation
    }, 200); // Delay for animation effect
  };

    // Set the first section as selected when modal opens
  useEffect(() => {
    if (isOpen && dataFields.length > 0) {
      setSelectedSection(0); // Select first item by default
      setIsVisible(true);
    }
  }, [isOpen, dataFields]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{
          display: 'block',
          background: 'rgba(0, 0, 0, 0.5)',
        }}
        aria-labelledby="exampleModalLabel"
        aria-hidden="false"
      >
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className={`modal-content p-3 ${isOpen ? 'open' : ''}`}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close-amenities"
                onClick={closeModal}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>

              <div className="modal-text">
                <div className="row mt-3 w-100">
                  {/* Sidebar */}
                  <div className="col-md-3 property_detail_sidebar">
                    <div className="mob-hide">
                      <div className="accordion mt-0">
                        {dataFields.map((field, index) => (
                          <div key={index} className="accordion-item" data-aos='fade-right' data-aos-delay={index*100}>
                            <h2 className="accordion-header">
                              <p
                                className={`accordian-btn ${selectedSection === index ? 'active' : ''}`}
                                onClick={() => handleSectionClick(index)}
                                style={{
                                  cursor: 'pointer',
                                  padding: '10px',
                                  margin: '5px 0',
                                  background: selectedSection === index ? '#007bff' : '#f8f9fa',
                                  color: selectedSection === index ? '#fff' : '#000',
                                  borderRadius: '5px',
                                  transition: 'background 0.3s ease-in-out, color 0.3s ease-in-out',
                                }}
                              >
                                {field}
                              </p>
                            </h2>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Right Content (Slide-Up Effect) */}
                  <div className="col-md-9" data-aos='fade-left'>
                    {selectedSection !== null && (
                      <div
                        className="overview-section"
                        style={{
                          opacity: isVisible ? 1 : 0,
                          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                          transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
                        }}
                      >
                        <h1 className="overview-heading desc-title">{dataFields[selectedSection]}</h1>
                        <p className="overview-paragraph">
                        {dataDescriptions[selectedSection]}
                        </p>
                      </div>
                    )}
                    {selectedSection === null && (
                      <p className="text-center mt-3">Click on a section to view details.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TipModal;
